module.exports = __webpack_public_path__ + "static/img/AU.10b4c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/AU.svg
// module id = Bb4m
// module chunks = 66